import EventsService from '@/services/EventsService'

export default {
  state: {
    reservations: [],
    loadingReservations: false
  },
  getters: {
    reservations: state => state.reservations,
    loadingReservations: state => state.loadingReservations
  },
  mutations: {
    setReservations (state, data) {
      state.reservations = data
    },
    setLoadingReservations (state, data) {
      state.loadingReservations = data
    }
  },
  actions: {
    async loadReservations ({ commit }, spaces) {
      if (!spaces || !spaces.length) {
        console.error('Invalid spaces recived', spaces)
        return
      }

      commit('setLoadingReservations', true)

      const ids = spaces.map(space => space['r25:id']).toString()
      const response = await EventsService.getReservations(ids, 0, 14)

      const items = response['r25:reservations']['r25:reservation']

      if (!items) {
        commit('setLoadingReservations', false)
        return
      }

      const addedIds = []
      const output = []

      items.forEach(item => {
        const event = item['r25:event']
        let willAdd = true

        if (event['r25:custom_attribute']) {
          let attributes = []

          if (!event['r25:custom_attribute'].length) {
            attributes = [event['r25:custom_attribute']]
          } else {
            attributes = event['r25:custom_attribute']
          }

          attributes.forEach(attribute => {
            if (
              (attribute['r25:attribute_id'] === '22' && attribute['r25:attribute_value'] === 'T') || // Invite Only
              (attribute['r25:attribute_id'] === '21' && attribute['r25:attribute_value'] === 'F') || // Open to the public
              (attribute['r25:attribute_id'] === '20' && attribute['r25:attribute_value'] === 'T')) { // Hide on web calendars
              willAdd = false
            }
          })
        }

        if (event['r25:event_type_id'] === '48' || event['r25:event_type_id'] === '290') { // Is a class
          willAdd = false
        }

        if (!addedIds.includes(event['r25:event_id']) && willAdd) {
          addedIds.push(event['r25:event_id'])

          output.push(item)
        }
      })

      commit('setLoadingReservations', false)
      commit('setReservations', output)
    }
  }
}
